import { useEffect, useState } from "react";

/**
 * Viewport-based media-query hook. Unlike `useIsMobile` (which keys off
 * `screen.width`, the physical device resolution that never changes on resize),
 * this tracks the live viewport via `window.matchMedia`, so it reacts to browser
 * resizing and DevTools device emulation — the behaviour the responsive app shell needs.
 */
export const useMediaQuery = (query: string) => {
  const [matches, setMatches] = useState(() => (typeof window !== "undefined" ? window.matchMedia(query).matches : false));

  useEffect(() => {
    const mql = window.matchMedia(query);
    const handler = () => setMatches(mql.matches);

    handler();
    mql.addEventListener("change", handler);

    return () => mql.removeEventListener("change", handler);
  }, [query]);

  return matches;
};
